import { DataGridPro } from '@mui/x-data-grid-pro';
import styled from 'styled-components';
import { GOODWAY_LIGHT, GOODWAY_WHITE, GOODWAY_YELLOW } from '../../constants/colors';

const StyledDataGrid = styled(DataGridPro)`
  && {
    width: 100%;
    margin: 0 auto;
    border: none;
  }
  & .MuiDataGrid-columnHeader {
    height: 80px;
    font-size: 15px;
  }
  & .MuiDataGrid-columnHeader:focus-within {
    outline: none !important
  }
  & .MuiDataGrid-pinnedColumnHeaders {
    background: ${GOODWAY_LIGHT};
    border-right: none;   
  }
  & .MuiDataGrid-pinnedColumns {
    background: ${GOODWAY_LIGHT};
    border-right: none;
    font-weight 200;
  }
  & .MuiDataGrid-cell:focus-within{
    outline: none !important;
  }
  & .MuiDataGrid-rowCount {
    display: none;
  }
  & .MuiDataGrid-columnHeaderTitle {
    color: ${GOODWAY_YELLOW};
    font-weight 300;
  }
  
  & .MuiDataGrid-iconSeparator {
    display: none !important;
  }

  /* Hide column separators by default for all columns */
  & .MuiDataGrid-columnSeparator {
    display: none !important;
  }

  /* Only show separators for resizable columns */
  & .MuiDataGrid-columnHeader.resizable .MuiDataGrid-columnSeparator {
    display: block !important;
    position: absolute !important;
    inset: 0 0 0 auto;       /* stick to the right */
    width: 16px !important;  /* comfortable grab area */
    cursor: col-resize !important;
    background: transparent !important;
    z-index: 10;
  }

  /* draw a short, centered line for the visual */
  & .MuiDataGrid-columnHeader.resizable .MuiDataGrid-columnSeparator::after {
    content: "";
    position: absolute;
    right: 7px;                      /* place the line inside the grab area */
    top: 35%;                        /* start a bit down… */
    height: 30%;                     /* …only 30% tall */
    width: 1px;
    background-color: ${GOODWAY_YELLOW};
    opacity: 0.6;
  }

  /* hover effect */
  & .MuiDataGrid-columnHeader.resizable .MuiDataGrid-columnSeparator:hover::after {
    opacity: 1;
  }
  
  /* Hide column separator for checkbox selection column */
  & .MuiDataGrid-columnHeader[data-field="__check__"] .MuiDataGrid-columnSeparator {
    display: none !important;
  }
  

  & .MuiDataGrid-cellContent {
    color: white;
    font-weight: 100;
  }
  
  ${props =>
      props.selection
          ? `
      & .MuiDataGrid-row {
        cursor: pointer !important;
      }
      & .MuiDataGrid-cell:focus {
        outline:none !important;
        box-shadow: none !important;
      }
      & .MuiDataGrid-virtualScrollerRenderZone {
        position: initial !important;
      }
      & .MuiDataGrid-row.Mui-selected {
        max-width: 100% !important;
        border-radius: 5px;
        overflow-x: clip;
        box-sizing: border-box !important;
        border: 3px solid ${GOODWAY_YELLOW} !important;
        background-color: transparent !important;
      }`
          : ''}
  & .muidatagrid-row: {
    max-height: none !important;
  }
  & .muidatagrid-renderingzone: {
    max-height: none !important;
  }
  & .MuiToolbar-regular {
    color: white;
  }
  & path {
    color: ${GOODWAY_YELLOW};
  }
  .MuiInput-input {
    color: white;
    transition: color 0.5s;
    font-weight: 100;
    font-spacing: 0.05em;
  }
  
  .MuiDataGrid-selectedRowCount {
    color: ${GOODWAY_WHITE};
  }
  
  '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
    display: none;
  }
  
  '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track': {
    display: none;
  }
  
  '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
    display: none;
  }
  
  '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:hover': {
    display: none;
  }
`;

export default StyledDataGrid;
